// This file contains constants and global flags. These values cannot be changes through the application interface

export const serverURL = "http://localhost:5000"; // SERVER ADDRESS
//http://192.168.1.48:3000

export const wipFolder = "Work In Progress"; // Default autosave location
export const minSliceThickness = 0.25; // minimum distance (mm) between top and bottom of slice
export const minRoiThickness = 0.1; // minimum height (mm) of ROI
export const defaultPercentSliceWidth = 50; //default percent slice width thats set for CSI samples
export const decimalPoints = 2; // decimal point for SWS and thickness value display
export const circularNewLocRegion = [3, 10, 10]; //radius, cetner_x and center_y coordinates of the default circular new location region
export const locationTriangleOffsetPixels = 35; // distance between triangle selector and the 'show completed' bar. pixel height of location tabs + 'show completed' bar
export const csiTypes = ["SINGLE", "STL", "MMODE"]; // List of CSI subtypes as labelled by the server
export const wifiEnabled = true; // Flag to enable wifi related features/buttons
export const photoSampleEnabled = false;

// Map IDs
export const customFaceMapId = "CUSTOM_FACE_MAP";
export const faceMapId = "FACE_MAP";
export const frontBodyMapId = "Front";
export const backBodyMapId = "Back";
export const tempLocationId = "TEMPORARY_LOCATION";
export const tempLocationSymmetricalId = "TEMPORARY_LOCATION_SYMMETRICAL";

// Heatmode IDs
export const heatmapTmodeType = "HEATMAP_TMODE_TYPE";
export const heatmapEmodeType = "HEATMAP_EMODE_TYPE";

// Remote Study Status

export const remoteStatus = {
  sync: "SYNC", // study does not exist locally, requires sync
  divergent: "DIVERGENT", // Remote and local versions of the study have diverged with different study hash heads
  match: "MATCH", // Page for loading a previous exam
  localVersion: "LOCAL_VERSION", // Local version includes changes not present on remote
  remoteVersion: "REMOTE_VERSION", // Remote version includes changes not present on local
  local: "LOCAL", // study does not exist on remote, only local
};

// Birth Year wheel picker
let yearEnd = new Date().getFullYear();
let yearStart = new Date().getFullYear() - 81;
export let birthYearWheel = Array(yearEnd - yearStart + 1)
  .fill()
  .map(() => {
    let increment = yearEnd--;
    if (increment === yearStart) {
      increment = `<${increment++}`;
    }
    return { label: increment.toString(), value: increment.toString() };
  });
